import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Button, Space, Table, notification } from 'antd';
import axios from 'axios';
import dayjs from 'dayjs';

import { statuses } from '@/config';
import useGlobalConfig from '@/store/global';

const FreetrialRequest = () => {
  const { themeColor } = useGlobalConfig();
  const navigator = useNavigate();
  const [freetrialRequest, setFreetrialRequest] = useState([]);
  const [tableLoading, setTableLoading] = useState(true);
  const [api, contextHolder] = notification.useNotification();
  const [currentPage, setCurrentPage] = useState(1);
  const [meta, setMeta] = useState({
    total: 0,
  });

  const loadData = async () => {
    setTableLoading(true);
    try {
      const { data, meta } = await axios.get(`free_trial_requests?page=${currentPage}`);
      setFreetrialRequest(data);
      setMeta(meta);
    } catch (e) {
      api.error({
        message: 'Load data failed',
        description: 'Something is wrong.',
        duration: 0,
      });
      console.error(e);
    } finally {
      setTableLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, [currentPage]);

  const columns = [
    {
      title: 'Date Requested',
      dataIndex: 'created_at',
      key: 'created_at',
      align: 'center',
      render: (text: string) => (text ? dayjs(text).format('MM-DD-YYYY') : '-'),
    },
    {
      title: 'Status',
      key: 'status',
      dataIndex: 'status',
      align: 'center',
      render: (_: any, record: any) => {
        const status = statuses.find((status) => status.value === record.status);
        return (
          <>
            <span className={`${status?.color} rounded-md px-2 py-1 text-white`}>
              {status?.label}
            </span>
          </>
        );
      },
    },
    {
      title: 'Patient Name',
      dataIndex: 'patient_first_name',
      key: 'patient_first_name',
      align: 'center',
      render: (_: any, record: any) => (
        <>
          <span>
            {record.patient_first_name} {record.patient_last_name}
          </span>
        </>
      ),
    },
    {
      title: 'Date of Birth',
      dataIndex: 'patient_date_of_birth',
      key: 'patient_date_of_birth',
      align: 'center',
      render: (text: string) => (text ? dayjs(text).format('MM-DD-YYYY') : '-'),
    },
    {
      title: 'Gender',
      dataIndex: 'patient_gender',
      key: 'patient_gender',
      align: 'center',
    },
    {
      title: 'Actions',
      key: 'action',
      align: 'center',
      render: (_: any, record: any) => (
        <Space size="middle">
          <Button
            onClick={() => (window.location.href = `/requests/free_trial_requests/${record.id}`)}
          >
            {record.status === 'medmonk_submitted' ? 'Complete Request' : 'View Request'}
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <>
      {contextHolder}
      <div className="py-8">
        <div>
          <Button
            style={{ backgroundColor: themeColor, color: 'white' }}
            className="mb-4"
            onClick={() => navigator('/requests/free_trial_requests/new')}
          >
            Request Free Trial Drug
          </Button>
        </div>
        <Table
          loading={tableLoading}
          rowKey="id"
          bordered
          columns={columns as any}
          dataSource={freetrialRequest}
          pagination={{
            current: currentPage,
            pageSize: 10,
            total: meta?.total,
            onChange: (page) => setCurrentPage(page),
          }}
        />
      </div>
    </>
  );
};

export default FreetrialRequest;
